import { createSlice, type PayloadAction } from "@reduxjs/toolkit"
import type { RootState } from "store"
import type { IDevice, IDeviceEvent } from "types/deviceTypes"

interface DeviceState {
  devices: Array<IDevice>
  deviceEvents: Array<IDeviceEvent>
  currentDevice: IDevice | undefined
}

const initialState: DeviceState = {
  devices: [] as IDevice[],
  deviceEvents: [] as IDeviceEvent[],
  currentDevice: undefined,
}

export const deviceSlice = createSlice({
  name: "device",
  initialState,
  reducers: {
    setDevices: (state, action: PayloadAction<Array<IDevice>>) => {
      state.devices = action.payload
    },
    setDevicesEvents: (state, action: PayloadAction<Array<IDeviceEvent>>) => {
      state.deviceEvents = action.payload
    },
    setCurrentDevice: (state, action: PayloadAction<IDevice>) => {
      state.currentDevice = action.payload
    },
    updateDevice: (state, action: PayloadAction<IDevice>) => {
      var index = state.devices.findIndex((x) => x.id === action.payload.id)

      if (index !== -1) {
        state.devices[index] = action.payload
      }
    },
    removeDevice: (state, action: PayloadAction<IDevice>) => {
      var index = state.devices.findIndex((x) => x.id === action.payload.id)

      if (index !== -1) {
        state.devices.splice(index, 1)
      }
    },
    resetDevice: (state, _action) => {
      state.devices = []
      state.deviceEvents = []
      state.currentDevice = undefined
    },
  },
})

export const {
  setDevices,
  updateDevice,
  removeDevice,
  setCurrentDevice,
  setDevicesEvents,
  resetDevice,
} = deviceSlice.actions

// Other code such as selectors can use the imported `RootState` type
export const selectCount = (state: RootState) => state.device

export default deviceSlice.reducer
